import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useClienteContext } from '../../../contexts/ClienteContext';
import { useEmpresaContext } from '../../../contexts/EmpresaContext';
import Navbar from '../Navbar/Navbar';
import MensajeToken from '../MensajeToken/MensajeToken';
import PerfilCliente from '../PerfilCliente/PerfilCliente';
import axiosAuth from '../../../services/axiosAuth';
import axios from 'axios';

export default function LayoutCliente() {

  const sucursal = localStorage.getItem('sucursal');
  const navigate = useNavigate();
  const { addCliente } = useClienteContext();
  const { addEmpresa } = useEmpresaContext();
  const [mensajeError, setMensajeError] = useState('');
  const [toggleMenu, setToggleMenu] = useState(false);
  const [isModalOpenPerfil, setIsModalOpenPerfil] = useState(false);

  useEffect(() => {
    getCliente();
  }, []);

  const getCliente = async () => {
    const token = localStorage.getItem('auth_cliente');
    if (!token) {
      navigate('/login');
      return;
    }
    try {
      const response = await axiosAuth.get(`/home/${sucursal}`);
      addCliente(response.data.datosCliente.datosCliente);

      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/empresa/${sucursal}`);
      addEmpresa(res.data[0]);

    } catch (error) {
      const mensaje = error.response?.data?.message || error.message;
      setMensajeError(mensaje);

      if (mensaje === 'El tiempo ha expirado. Vuelva a iniciar sesion') {
        setToggleMenu(true);
        setTimeout(() => {
          localStorage.removeItem('auth_cliente');
          localStorage.removeItem('sucursal');
          localStorage.removeItem('admin');
          navigate('/login');
        }, 10000);
      }
    }
  };

  const logout = () => {
    localStorage.removeItem('auth_cliente');
    localStorage.removeItem('sucursal');
    localStorage.removeItem('admin');
    navigate('/login');
  };

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <div className="flex-shrink-0">
        <Navbar logout={logout} setIsModalOpenPerfil={setIsModalOpenPerfil} />
      </div>
      <div className="flex-1 overflow-hidden flex flex-col h-full">
        <Outlet />
      </div>
      {toggleMenu && <MensajeToken mensajeError={mensajeError} logout={logout} />}
      {isModalOpenPerfil && <PerfilCliente setIsModalOpenPerfil={setIsModalOpenPerfil} />}
    </div>
  );
}